import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { getCurrentSendedTakeOff, getPreviewWorkTime } from '../../../selectors/sended-data';
import { Takeoff } from '../../../icons';
import { checkTimeIsCorrect } from '../../../service/NavPointsUtils';

export const TakeOffTime = memo(({ className, onChangeTime }) => {
    const { timeEngineWorkBefore, value } = useSelector((state) => {
        const takeOff = getCurrentSendedTakeOff(state);
        const previewWorkTime = getPreviewWorkTime(state);

        return {
            value: takeOff.takeOffTime,
            timeEngineWorkBefore: previewWorkTime.timeEngineWorkBefore,
        };
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const takeOffSummary = React.useMemo(() => {
        return [
            {
                title: translate('flightInfoPage.engineRunBeforeTakeOff'),
                value: timeEngineWorkBefore,
                isCorrect: checkTimeIsCorrect(timeEngineWorkBefore),
            },
        ];
    }, [timeEngineWorkBefore, translate]);

    return (
        <ActionTimeControl
            title={translate('flightInfoPage.takeOffTime')}
            buttonName={translate('flightInfoPage.takeOff')}
            iconButton={<Takeoff width="30" height="30" />}
            iconMenuImg={<MoreVertIconContrast isContrast={true} />}
            text={translate('flightInfoPage.aircraftTookOffOn')}
            name="takeOffTime"
            value={value}
            summary={takeOffSummary}
            onChange={onChangeTime}
            className={className}
        />
    );
});
